export const useOnChangeHandlers = ({
  setAnchorEl,
  setHours,
  onEstimatedHoursChange,
  hours
}) => {
  const onEstimatedHoursClick = event => {
    setAnchorEl(event.target);
  };

  const handleChange = event => {
    const value =
      event.target && event.target.value ? parseFloat(event.target.value) : 0;

    setHours(value);
  };

  const onClose = () => {
    setAnchorEl(null);
  };

  const handleOnBlur = () => {
    onEstimatedHoursChange(hours);
    onClose();
  };

  const handleHoursKeyPress = event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleOnBlur();
    }
  };

  return {
    onEstimatedHoursClick,
    handleChange,
    handleOnBlur,
    handleHoursKeyPress
  };
};

export default useOnChangeHandlers;
